var render = function (_h,_vm) {var _c=_vm._c;return _c('img',{staticClass:"img-fluid",attrs:{"src":require(("@assets/images/svg-icon/" + (_vm.props.icon) + ".svg")),"alt":_vm.props.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }